import { render, staticRenderFns } from "./Left_Text.vue?vue&type=template&id=91225d24&scoped=true"
import script from "./Left_Text.vue?vue&type=script&lang=js"
export * from "./Left_Text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91225d24",
  null
  
)

export default component.exports